<template>
    <Modal
      :config="{ ...modalConfig.pdfPreview, ...internalConfig }"
      @cancel="onModalClose"
      @btn1Action="onModalClose"
    >
      <template v-slot:modalHeaderContent>
        <slot name="modalHeaderContent" />
      </template>
      <div slot="modalContent" id="viewPdfFile" class="pdf-viewer" data-qa="pdfpreview-div-1qmuh"></div>
    </Modal>
</template>

<script>
import PDFObject from '@/core/_helpers/pdfViewer'
import Modal from '@/components/common/Modal.vue'

export default {
  name: 'PDFPreview',
  components: {
    Modal
  },
  props: {
    PDFData: {
      type: String,
      default: undefined
    },
    config: {
      type: Object
    }
  },
  data () {
    return {
      modalConfig: {
        pdfPreview: {
          enabled: true,
          persistent: true,
          close: true
        }
      },
      pdfConfig: { forcePDFJS: true, pdfOpenParams: { view: 'FitH' }, height: '60vh', border: 'none' }
    }
  },
  created () {
    window.requestAnimationFrame(() => {
      PDFObject.embed(this.PDFData, '#viewPdfFile', this.pdfConfig)
    })
  },
  computed: {
    internalConfig () {
      const {
        width = '50%',
        title = this.$t('consolidatedStatement.modalTitle')
      } = this.config || {}
      return { ...this.config, width, title }
    }
  },
  methods: {
    onModalClose () {
      this.modalConfig.pdfPreview.enabled = false
      this.$emit('closePdfPreview')
    }
  }

}
</script>
